import { DeviceTypes } from "../../config";
import { PoolDeviceInterface, IOnoffable, IProbe } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDeviceOnOffable from "./base-onoffable";
import { PoolDeviceCriticalDesiredActual, DisplayProcessingLogics, StatesToDisplayItem } from "../Types";


export enum criticalFieldIdentifiers {
    OnOff = "OnOff"
}

export default class PoolDevicePHProbe extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable, IProbe {
    static CanBeAddedToflow = true;
    static Icon = "sensor-ph";
    static DeviceType = DeviceTypes.PHPROBE;
    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    static PickerTitle = Locale.gettext("PH Probe");

    canOverrideFromController() {
        return false;
    }

    isCalibrated(): boolean {
        // need to calibrate at least the 7ph calibration point, which is 2
        return this.getDeviceState(PoolsideDaemonDeviceStateNames.Calibrated)?.value >= 2;
    }

    getCriticalFields():PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }
    
        return fields;
    }
    
    getMainMetricField(): StatesToDisplayItem {
        if (this.siteStates.AutoFilterVersion >= 12) {
            return ({
                DisplayName: "Adjusted Value",
                DisplayNameShort: "Adjusted",
                DisplayOrder: 1,
                DisplayProcessingLogic: DisplayProcessingLogics.FLOAT,
                DisplayProcessingLogicUnitAsDisplayName: false,
                Name: PoolsideDaemonDeviceStateNames.Value
            });
        }
    }
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    PowerState = "PowerState",
    Calibrated = "Calibrated",
    RawValue = "RawValue",
    Value = "Value",
}
